import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../../services/resales-request';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import { Doughnut } from 'react-chartjs-2';

const Brands = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, elite: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({data:[]});
  const [company, setCompany] = useState([]);
  const [info, setInfo] = useState({segment:[],client_type:[]});
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})

  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [wasModified, setWasModified] = useState(false);
  const [messageErro, setMessageErro] = useState(false);
  const Data = [];

  useEffect(() => {
    if(localStorage.getItem('companyId')!=null){
      let users = ResalesRequestService.getResaleBrands(localStorage.getItem('companyId'),{ params: { ...filters } });
      users
      .then(data => {
        setReports(data);
      });
    } else {
      setMessageErro(true);
    }
  }, [filters]);


  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });
//Company Name	SAP	Main BU	Elite	Partnumber	Description	Vendor	Amount	Value	Purchase Date
  const columns = [
    {
      dataField: 'name',
      text: 'Razão Social',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'model',
      text: 'Partnumber',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'product',
      text: 'Descrição',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'manufacturer',
      text: 'Fabricante',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'quantity',
      text: 'Quantidade',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'value',
      text: 'Valor',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'date',
      text: 'Data da Compra',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  const renderData = () => {
    Object.values(reports.data).map((brand, k) => {
      Data.push({
        id: brand.id,
        name: brand.name,
        quantity:brand.quantity,
        value:brand.value,
        manufacturer:brand.manufacturer,
        product:brand.product,
        date:brand.date,
        model:brand.model,
      });
    });
  }
  renderData();
  const listBrands = ()=>{
    return (
        <>
          <Container fluid>
            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Row>
                      <Col xs={6} className="align-self-center">
                        <h4 className={styles.headerTitle}>
                          Marcas
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <hr className={styles.line} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3}>
                        <Form.Group>
                          <Form.Label>Registros por página:</Form.Label>
                          <Form.Control
                            as="select"
                            value={filters.per_page}
                            onChange={e =>
                              handleFilterChange({ per_page: e.target.value })
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Form.Group>
                          <Form.Label>Pesquisa:</Form.Label>
                          <Form.Control
                            as="input"
                            //value={filters.per_page}
                            onChange={e => handleFilterChange({ search: e.target.value })}
                          >
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <BootstrapTable
                      id="table"
                      className="font-10"
                      keyField="documets"
                      data={Data}
                      columns={columns}
                      //expandRow={expandRow}
                    />
                    <Row>
                      <Col>
                        <Trans i18nKey="label:interpolateShowingRecords">
                          Showing {{ from: reports.from || '0' }} to{' '}
                          {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                          records
                        </Trans>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Pagination
                          activePage={reports.current_page}
                          itemsCountPerPage={reports.per_page}
                          totalItemsCount={reports.total}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          prevPageText="‹"
                          nextPageText="›"
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
  };

  const randomColor = require('randomcolor');

  let color = randomColor({
    count: 10000,
    hue: 'random',
    luminosity: 'light',
  });

  const BrandsGraphic = ({ arr, arrName }) => {
    const { t } = useTranslation();
    let state;
    state = {
      dataDoughnut: {
        labels: arrName,
        datasets: [
          {
            data: arr,
            backgroundColor: color,
          },
        ],
      },
      options: {
        tooltips: {
          enabled: true,
          callbacks: {
            beforeLabel: function (tooltipItem, data) {
              return data.labels[tooltipItem.index];
            },
            label: function (tooltipItem, data) {
              let value = data.datasets[0].data[tooltipItem.index];
              if (parseInt(value) >= 1) {
                return value.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                });
              }
            },
          },
        },
        legend: {
          display: true,
        },
        maintainAspectRatio: true,
        title: {
          display: false,
          text: 'Marcas',
        },
        responsive: true,
      },
    };

    return (
      <Container>
        <Doughnut data={state.dataDoughnut} options={state.options} />
      </Container>
    );
  };

  const graphicBrands = ()=>{
    return(<>
    <Container fluid>
          <Row>
          <Col className="mt-2 mb-3" xs={6}>
          <Card
            className="shadow bg-white rounded mt-3 mb-3"
            style={{ height: '450px' }}
          >
            <Card.Header>Marcas</Card.Header>
            <Card.Body>
              {Data.length>0?(
                <BrandsGraphic arr={Data.map(a=>{
                  return a.value;
                })} arrName={Data.map(a=>{
                  return a.manufacturer;
                })} />
              ):(
                <div>
                  <h3 className="text-black mb-4 px-4 text-xl-center">Sem dados disponíveis</h3>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
        </Row>
        </Container>
    </>)
  }

  const showMessageErro = ()=>{
    return (
      <>
        <Container fluid>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card className="card border border-dark text-center col-8">
                <Card.Body>
                  <Row>
                    <Col className="col-12 align-self-center p-5">
                      <h3 className="text-black mb-4 px-4">Você precisa selecionar uma revenda para visualizar os dados.</h3>
                      <a className="btn btn-primary btn-lg" href="./" role="button" onClick={()=>{
                        localStorage.setItem('returnPage',window.location.href);
                      }}>Selecionar Revenda</a>
                    </Col>
                  </Row>
                </Card.Body> 
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };
return (<>{
messageErro?showMessageErro():graphicBrands()
}</>);
};

export default MasterPage(Brands);